import { ImportType } from '@/api/admin/import-type';
import { Button } from '@/components/ui/button';
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '@/components/ui/tooltip';
import { ColumnDef } from '@tanstack/react-table';
import { ArrowUpDown, Eye } from 'lucide-react';
import { Link } from 'react-router';

export const columns: ColumnDef<ImportType>[] = [
	{
		accessorKey: 'id',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Import Type Id
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => <div className="font-medium">{row.original.id}</div>,
	},
	{
		accessorKey: 'name',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Import Type
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => {
			return (
				<div className="whitespace-nowrap font-medium">{row.original.name}</div>
			);
		},
	},
	{
		id: 'actions',
		cell: ({ row }) => (
			<div>
				<TooltipProvider>
					<Tooltip>
						<TooltipTrigger asChild>
							<Link to={`/admin/import-type/${row.original.id}`}>
								<Button className="m-auto" variant="ghost">
									<Eye size={16} />
								</Button>
							</Link>
						</TooltipTrigger>
						<TooltipContent>
							<p>View Mappings</p>
						</TooltipContent>
					</Tooltip>
				</TooltipProvider>
			</div>
		),
	},
];
